//show sort icon(up/down arrow) based on the sort direction
//highlights active column

import React from "react";
import Typography from "../Typography";
import { RiArrowUpDownLine, RiArrowUpLine, RiArrowDownLine } from "react-icons/ri";

/**
 * Sortable table header component
 * @param {string} columnKey - Unique key for the column
 * @param {string} label - Display label for the column
 * {Function} onSort - Callback function when header is clicked
 * @param {string} currentSortKey - Currently active sort key
 * @param {string} sortDirection - Current sort direction ('asc' or 'desc')
 * @param {boolean} sortable - Whether the column is sortable (default: true)
 * @param {string} className - Additional CSS classes
 * @param {"start"|"center"|"end"} [align] - Header text alignment
 */
const SortableHeader = ({
  columnKey,
  label,
  onSort,
  currentSortKey,
  sortDirection,
  sortable = false,
  className = "",
  align = "start",
}) => {
  const isActive = currentSortKey === columnKey;
  const isAsc = sortDirection === "asc";
  const alignClass =
    align === "center" ? "text-center" : align === "end" ? "text-end" : "text-start";
  const flexJustify = align === "center" ? "justify-center" : align === "end" ? "justify-end" : "";

  const handleClick = () => {
    if (sortable && onSort) {
      onSort(columnKey);
    }
  };

  return (
    <th
      className={`${alignClass} leading-none p-0 ${
        sortable ? "cursor-pointer select-none hover:bg-surface-tertiary" : ""
      } ${className}`}
      onClick={handleClick}
      scope="col"
    >
      <div className={`flex items-center gap-1.5 leading-none ${flexJustify}`}>
        <span className="text-sm font-semibold leading-none">{label}</span>
        {sortable && (
          <span className="text-sm leading-none flex items-center">
            {isActive ? (
              isAsc ? (
                <RiArrowUpLine className="text-sm text-theme-primary" />
              ) : (
                <RiArrowDownLine className="text-sm text-theme-primary" />
              )
            ) : (
              <RiArrowUpDownLine className="text-sm text-text-secondary opacity-50" />
            )}
          </span>
        )}
      </div>
    </th>
  );
};

export default SortableHeader;
